

const ZERO_STATE = {
  wlfs: [],
}

const wlfs_reducer = (state = ZERO_STATE, action) => {

  return state;
}

export { wlfs_reducer };
